//Library modul
import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

//Personal Component

//Redux function
import { edit_properties_upload } from "../../App/actions/layerActions";

//Picture Asset
import icon_upload from "../../Assets/svg/icon_upload.svg";

//General Function
import uuid from "../../App/validation/uuid";
import { getGeoLayer } from "../../App/reduxHelper/layer";
// import dict from "../../Data/dict.json";

// const language = localStorage?.language ? localStorage?.language : "ina";

const UploadImage = ({
  geo_layer_id,
  feature_key,
  properties_key,
  params,
  set_textfield,
  handlePreviewImage,
}) => {
  const dispatch = useDispatch();
  const layer = useSelector((state) => state.layer);
  const fileInput = useRef(null);

  const handle_submit = async (e) => {
    e.preventDefault();
    const file = fileInput.current.files[0];

    if (!file) return;

    const body_file = {
      file: file,
      file_name: `img_%${file?.name}_%${uuid()}`,
      dirname: "properties",
    };

    const body_database = {
      geo_layer_id: geo_layer_id,
      feature_key: feature_key,
      properties_key: properties_key,
      properties_value: "", //boleh dikosongkan karena akan ditimpa dengan url dengan methode edit_properties_image
    };

    let body = {
      body_file,
      body_database,
      mode: "image",
    };

    const result = await dispatch(
      edit_properties_upload(
        body,
        getGeoLayer(layer)?.architecture,
        geo_layer_id,
        params,
      ),
    );

    if (set_textfield) {
      set_textfield(result?.properties_value, properties_key);
    } else if (handlePreviewImage) {
      handlePreviewImage(result?.properties_value);
    }
  };

  return (
    <label className="fileContainer">
      <div
        className="hover_darkGreen hover_bigger"
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: "10px",
          width: 15,
          height: 15,
          backgroundColor: "#e6eef3",
          padding: "5px",
          border: "1px solid #9ca8bb",
          borderRadius: "99px",
        }}
      >
        <img
          src={icon_upload}
          className="h_15 w_15 rounded"
          alt="upload system"
        />
        {/* {dict["Upload image"][language]} */}
      </div>
      <input
        id={`${feature_key}-${properties_key}`}
        style={{ display: "none" }}
        type="file"
        accept="image/*"
        ref={fileInput}
        onChange={handle_submit}
      />
    </label>
  );
};

export default UploadImage;
